import { render, staticRenderFns } from "./ResultBlockSecondary.vue?vue&type=template&id=2080cdee&scoped=true&"
import script from "./ResultBlockSecondary.vue?vue&type=script&lang=js&"
export * from "./ResultBlockSecondary.vue?vue&type=script&lang=js&"
import style0 from "./ResultBlockSecondary.vue?vue&type=style&index=0&id=2080cdee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2080cdee",
  null
  
)

export default component.exports